var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Import react components
import React, { Component } from 'react';
import { connect } from 'react-redux';
import SvgImage from '@material-ui/icons/Image';
import { withStyles } from '@material-ui/core/styles';
import { getTranslate } from 'react-localize-redux';
// IMAGE SIZE (not used anymore, declared actual style inside of class to use props (styles.image1))
var styles = function (theme) { return ({
    image: {
        verticalAlign: 'top',
        margin: 'auto',
        maxWidth: '100%',
        minWidth: '100px',
        width: 'auto',
        maxHeight: '100%',
        minHeight: '100%',
    }
}); };
/**
 * Create component class
 */
var ImgComponent = /** @class */ (function (_super) {
    __extends(ImgComponent, _super);
    /**
     * Component constructor
     * @param  {object} props is an object properties of component
     */
    function ImgComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.styles = {
            loding: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100px',
                position: 'relative',
                color: '#cacecd',
                fontWeight: 400
            },
            loadingContent: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            },
            loadingImage: {
                fill: 'aliceblue',
                width: '50px',
                height: '50px'
            },
            image1: {
                verticalAlign: 'top',
                margin: 'auto',
                maxWidth: '100%',
                minWidth: '100px',
                // width: '100%',
                height: _this.props.height || '350px',
                borderRadius: _this.props.borderRadius || '',
                maxHeight: _this.props.maxHeight,
                minHeight: '100%',
            }
        };
        _this.handleLoadImage = function () {
            _this.setState({
                isImageLoaded: true
            });
        };
        // Defaul state
        _this.state = {
            isImageLoaded: false,
            imageURL: props.fileName,
            fillOption: 'contain'
        };
        // Binding functions to `this`
        _this.handleLoadImage = _this.handleLoadImage.bind(_this);
        return _this;
    }
    /**
     * Will be called on loading image
     *
     * @memberof Img
     */
    ImgComponent.prototype.componentDidMount = function () {
        if (this.state.imageURL) {
            var myimg = new Image();
            myimg.src = this.props.fileName;
            if (myimg.width !== 0) {
                // console.log('imageW', myimg.width)
                // console.log('imageH', myimg.height)
                if (myimg.height < 750 || myimg.width < 400) {
                    this.setState({
                        fillOption: 'cover'
                    });
                }
            }
        }
    };
    /**
     * Reneder component DOM
     * @return {react element} return the DOM which rendered by component
     */
    ImgComponent.prototype.render = function () {
        var _a = this.props, fileName = _a.fileName, style = _a.style, translate = _a.translate;
        var isImageLoaded = this.state.isImageLoaded;
        var classes = this.props.classes;
        return (React.createElement("div", { style: {
                width: this.props.width || 'auto',
                maxHeight: this.props.height || '350px',
                height: this.props.height || '350px',
                borderStyle: 'solid',
                borderWidth: '0px',
                textAlign: 'center'
            } },
            React.createElement("img", { className: classes.image, onLoad: this.handleLoadImage, src: fileName || '', style: isImageLoaded ? {
                    verticalAlign: 'top',
                    margin: 'auto',
                    maxWidth: '100%',
                    minWidth: '100px',
                    width: window.outerWidth < 500 ? '100%' : 'auto',
                    height: this.props.height || '350px',
                    borderRadius: this.props.borderRadius || '',
                    maxHeight: this.props.maxHeight,
                    minHeight: '100%',
                    objectFit: window.outerWidth < 500 ? this.props.objectFit || 'cover' : this.props.objectFit || this.state.fillOption
                } : { margin: '15%', display: 'none' } }),
            React.createElement("div", { style: Object.assign({}, { backgroundColor: 'white' }, isImageLoaded ? { display: 'none' } : this.styles.loding) },
                React.createElement("div", { style: this.styles.loadingContent },
                    React.createElement(SvgImage, { style: this.styles.loadingImage }),
                    React.createElement("div", null, translate('image.notLoaded'))))));
    };
    return ImgComponent;
}(Component));
export { ImgComponent };
/**
 * Map dispatch to props
 * @param  {func} dispatch is the function to dispatch action to reducers
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapDispatchToProps = function (dispatch, ownProps) {
    return {};
};
/**
 * Map state to props
 * @param  {object} state is the obeject from redux store
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapStateToProps = function (state, ownProps) {
    return {
        translate: getTranslate(state.get('locale')),
        avatarURL: state.getIn(['imageGallery', 'imageURLList']),
        imageRequests: state.getIn(['imageGallery', 'imageRequests'])
    };
};
// - Connect component to redux store
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ImgComponent));



//////////////////
// WEBPACK FOOTER
// ./src/components/img/ImgComponent.tsx
// module id = 1109
// module chunks = 0 1 2 3 4 5 6 7